<template>
  <div id="couponType">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>优惠券</el-breadcrumb-item>
          <el-breadcrumb-item>优惠券设置</el-breadcrumb-item>
          <el-breadcrumb-item>特殊优惠券管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{navigationMap[couponTypeActiveName]}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠券类型::">
          <el-select v-model="selfTypeID"
                     filterable
                     placeholder="请选择优惠券类型类型">
            <el-option v-for="item in statusList"
                       :key="item.fTypeID"
                       :label="item.Title"
                       :value="item.fTypeID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="couponTypeListQuery">查询</el-button>
        </el-form-item>
        <el-form-item style="float:right;margin-right:0px;">
          <el-button type="primary"
                     size="small"
                     @click="addCouponType">新增特殊优惠券</el-button>
          <el-button type="primary"
                     size="small"
                     @click="syncAll"
                     v-if="is_syn">批量下发</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="couponTypeActiveName"
               type="card"
               @tab-click="tabClick">
        <el-tab-pane label="特殊优惠券列表"
                     name="couponTypeList">
          <el-row>
            <el-table :data="couponTypeList"
                      border
                      highlight-current-row
                      style="width: 100%"
                      v-loading="loading"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fOpLastTimeTitle"
                               label="最后同步时间">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="160"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fParkName"
                               label="场库">
              </el-table-column>
              <el-table-column prop="fCouTypeName"
                               label="名称/卡号">
              </el-table-column>
              <el-table-column prop="fCouTypeName"
                               label="类型">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
              <el-table-column fixed="right"
                               align="left"
                               label="操作"
                               width="320">
                <template slot-scope="scope">
                  <el-button @click="viewCouponType(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editCouponType(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deleteCouponType(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             @click="synCouponType(scope.$index, scope.row,false)"
                             v-if="is_syn">上传</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="待同步"
                     name="syncouponTypeList">
          <el-row>
            <el-table :data="syncouponTypeList"
                      border
                      :row-class-name="tableRowClassName"
                      highlight-current-row
                      style="width: 100%"
                      v-loading="loading"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="160"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fParkName"
                               label="场库">
              </el-table-column>
              <el-table-column prop="fCouTypeName"
                               label="名称/卡号">
              </el-table-column>
              <el-table-column prop="fCouponValueTitle"
                               label="类型">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
              <el-table-column prop="fSyncRemark"
                               label="同步说明">
              </el-table-column>
              <el-table-column fixed="right"
                               align="center"
                               label="操作"
                               width="320">
                <template slot-scope="scope">
                  <el-button @click="viewCouponType(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editCouponType(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deleteCouponType(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             @click="synCouponType(scope.$index, scope.row,true)"
                             v-if="is_syn">下发</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="couponTypeEditOrDetail">
      <el-dialog :title="detailTitle"
                 :visible.sync="couponTypeEditOrDetailVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="30%">
        <el-form :model="curRowInfo"
                 :rules="rules"
                 ref="form"
                 label-width="120px">
          <el-row>
            <el-col :span="23">
              <el-form-item label="客户::"
                            prop="fCustID">
                <el-select v-model="curRowInfo.fCustID"
                           filterable
                           placeholder="请选择客户"
                           :disabled="!curRowInfo.isEdit"
                           @change="setPark($event)"
                           style="width: 100%">
                  <el-option v-for="item in choiceCusts"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23">
              <el-form-item label="优惠券类型::"
                            prop="fTypeID">
                <el-select v-model="curRowInfo.fTypeID"
                           filterable
                           placeholder="请选优惠券类型"
                           :disabled="!curRowInfo.isEdit"
                           style="width: 100%">
                  <el-option v-for="item in statusList"
                             :key="item.fTypeID"
                             :label="item.Title"
                             :value="item.fTypeID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23">
              <el-form-item label="场库名称::"
                            prop="fParkID">
                <el-select v-model="curRowInfo.fParkID"
                           filterable
                           placeholder="请选择场库"
                           :disabled="!curRowInfo.isEdit"
                           style="width: 100%">
                  <el-option v-for="item in parks"
                             :key="item.fParkID"
                             :label="item.fParkName"
                             :value="item.fParkID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23">
              <el-form-item :label="fCouTypeTitle"
                            prop="fCouTypeName">
                <el-input v-model="curRowInfo.fCouTypeName"
                          :placeholder="fCouTypeTitle2"
                          autocomplete="off"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23">
              <el-form-item label="优惠券抵扣方式::">
                <el-select v-model="curRowInfo.fCouponType"
                           filterable
                           placeholder="请选择优惠券抵扣方式"
                           :disabled="!curRowInfo.isEdit"
                           @change="setCouponValue($event)"
                           style="width: 100%">
                  <el-option v-for="item in choiceCouponTypeList"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23">
              <el-form-item :label="fCouponValueTitle"
                            prop="fCouponValue">
                <el-input v-model="curRowInfo.fCouponValue"
                          autocomplete="off"
                          :disabled="!curRowInfo.isEdit || couponValueEnable"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23">
              <el-form-item label="备注::"
                            prop="fRemark">
                <el-input v-model="curRowInfo.fRemark"
                          type="textarea"
                          placeholder="请输入备注"
                          autocomplete="off"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitForm('form')"
                     :loading="save_loading"
                     v-if="curRowInfo.isEdit">{{save_msg}}</el-button>
          <el-button @click="couponTypeEditOrDetailVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog title="批量下发"
                 :visible.sync="synDataVisible"
                 width="450px"
                 v-dialogDrag>
        <el-form label-width="100px"
                 :model="syncData"
                 :rules="synRules"
                 ref="ruleForm"
                 style="margin-top:20px">
          <el-form-item label="选择客户::"
                        prop="fCustID">
            <el-select v-model="syncData.fCustID"
                       filterable
                       style="width:250px"
                       placeholder="请选择客户">
              <el-option v-for="item in offlineCusts"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="syncAllOk('ruleForm')">确定</el-button>
          <el-button @click="synDataVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { coupon as api } from '../../api/coupon'
import * as user from '../../api/user'
import { mapActions } from 'vuex'
export default {
  name: 'couponType.vue',
  data () {
    var validateName = (rule, value, callback) => {
      if ((value || '').length > 0) {
        var patrn = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/
        if (!patrn.test(value)) {
          callback(new Error('不能包含特殊字符'))
        }
      }
      callback()
    }
    return {
      save_loading: false,
      save_msg: '保存',
      synDataVisible: false,
      syncData: {
        fCustID: ''
      },
      synRules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ]
      },
      curRowInfo: {
        op: '',
        isEdit: false,
        fCustID: '',
        fTypeID: '0',
        fParkID: '',
        fCouTypeName: '',
        fCouponType: '',
        fCouponValue: '',
        fRemark: ''
      },
      formLabelWidth: '120px',
      couponTypeEditOrDetailVisible: false,
      detailTitle: '',
      syncouponTypeList: [],
      couponTypeList: [],
      loading: false,
      is_edit: false,
      is_del: false,
      is_syn: false,
      is_pwd: false,
      navigationMap: {
        couponTypeList: '特殊优惠券列表',
        syncouponTypeList: '待同步'
      },
      selfTypeID: '0',
      selCustID: '',
      choiceCusts: [],
      offlineCusts: [],
      choiceCouponTypeList: [],
      parks: [{ 'fParkID': '0', 'fParkName': '所有停车场' }],
      statusList: [],
      couponTypeActiveName: 'couponTypeList',
      tableHeight: 0,
      rules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        fCouTypeName: [
          { required: true, message: '请输入名称/卡号', trigger: 'blur' },
          { validator: validateName, trigger: 'blur' },
          { min: 1, max: 99, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ]
      },
      pageSize: 20,
      pageNo: 1,
      total: 0,
      couponValueEnable: false
    }
  },
  computed: {
    fCouTypeTitle: function () {
      if (this.curRowInfo.fTypeID === '0') {
        return '名称::'
      } else {
        return '卡号::'
      }
    },
    fCouTypeTitle2: function () {
      if (this.curRowInfo.fTypeID === '0') {
        return '请输入名称'
      } else {
        return '请输入卡号'
      }
    },
    fCouponValueTitle: function () {
      let value = this.curRowInfo.fCouponType
      let text = ''
      for (var i = 0; i < this.choiceCouponTypeList.length; i++) {
        if (this.choiceCouponTypeList[i].value === value) {
          text = this.choiceCouponTypeList[i].text
        }
      }
      return text + '::'
    }
  },
  methods: {
    ...mapActions([
      'getCustByGroup', 'getParkList'
    ]),
    setCouponValue (val) {
      this.curRowInfo.fCouponValue = ''
      this.couponValueEnable = false
      if (val === '0') {
        this.curRowInfo.fCouponValue = 0
        this.couponValueEnable = true
      }
    },
    setPark (val) {
      this.parks = []
      this.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parks = data.Data || []
            }
          }
          let all = {}
          all['fParkID'] = '0'
          all['fParkName'] = '所有停车场'
          this.parks.unshift(all)
          this.curRowInfo.fParkID = '0'
        }
      })
    },
    setDefault () {
      let tmp = this.curRowInfo.fCouponType
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
      this.curRowInfo['fTypeID'] = '0'
      this.curRowInfo['fParkID'] = '0'
      this.curRowInfo.fCouponType = tmp
    },
    syncAll () {
      this.syncData.fCustID = ''
      this.synDataVisible = true
    },
    syncAllOk (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tmpCust = this.choiceCusts.filter(item => {
            if (item.fCustID === this.syncData.fCustID) { return item }
          })
          var isSyn = this.couponTypeActiveName === 'syncouponTypeList'
          var tip = '将客户[' + tmpCust[0].fCustName + ']的【特殊优惠券列表】，从云平台批量下发同步到线下客户端, 是否继续?'
          var synTip = '将客户[' + tmpCust[0].fCustName + ']的【待同步】，从云平台批量下发同步到线下客户端, 是否继续?'
          this.$confirm(isSyn ? synTip : tip, '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => {
            api.synCouponTypeById({
              fCustID: this.syncData.fCustID,
              fIsSyn: isSyn
            }).then(res => {
              if (res && res.data) {
                let { status, data } = res
                if (status === 200) {
                  if (data.IsOk) {
                    this.$message({
                      type: 'success',
                      message: '操作完成'
                    })
                    this.synDataVisible = false
                  } else {
                    this.$message.error('提示：' + data.Msg)
                  }
                }
              }
            })
          }).catch(() => { })
        }
      })
    },
    synCouponType (index, row, isSyn) {
      if (row && row !== null && typeof (row) !== 'undefined') {
        var msg = ''
        if (isSyn) {
          msg = '从云平台下发同步到线下客户端'
        } else {
          msg = '从线下客户端上传同步到云平台'
        }
        this.$confirm('将客户[' + row.fCustName + ']的特殊优惠券[' + row.fCouTypeName + ']' + msg + ', 是否继续?', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          api.synCouponTypeById({
            fBigRowID: row.fBigRowID,
            fIsSyn: isSyn
          }).then(res => {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: '操作完成'
                })
                this.initData()
              } else {
                this.$message.error('提示：' + data.Msg)
              }
            }
          })
        }).catch(() => { })
      }
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save_loading = true
          this.save_msg = '保存中…'
          api.saveCouponType(this.curRowInfo).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            let { status, data } = res
            if (status !== 200) {
              this.$message.error('提示：特殊优惠券操作出错')
            } else {
              if (!data.IsOk) {
                this.$message.error(data.Msg)
              } else {
                this.initData()
                this.$message.success(data.Msg)
                this.couponTypeEditOrDetailVisible = false
              }
            }
          })
        } else {
          console.log('couponType error submit!!')
          return false
        }
      })
    },
    addCouponType () {
      this.setDefault()
      this.couponTypeEditOrDetailVisible = true
      this.curRowInfo.op = 'add'
      this.curRowInfo.isEdit = true
      this.detailTitle = '新增特殊优惠券'
      setTimeout(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      }, 50)
    },
    editCouponType (index, row) {
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate()
      }
      if (row && row !== null && typeof (row) !== 'undefined') {
        let curRow = {}
        Object.assign(curRow, row)
        this.curRowInfo = curRow
        this.detailTitle = '【' + row.fCouTypeName + '】编辑特殊优惠券'
        this.curRowInfo.isEdit = true
        this.curRowInfo.op = 'edit'
        this.curRowInfo.fIsSyn = this.couponTypeActiveName === 'syncouponTypeList'
        this.couponTypeEditOrDetailVisible = true
      }
    },
    viewCouponType (row) {
      this.curRowInfo.isEdit = false
      if (row && row !== null && typeof (row) !== 'undefined') {
        Object.assign(this.curRowInfo, row)
        this.detailTitle = '【' + row.fCouTypeName + '】查看特殊优惠券'
        this.couponTypeEditOrDetailVisible = true
      }
    },
    deleteCouponType (index, row) {
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let curRow = {}
        Object.assign(curRow, row)
        curRow['fIsSyn'] = this.couponTypeActiveName === 'syncouponTypeList'
        api.deleteCouponType(curRow).then(res => {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: data.Msg
              })
              this.initData()
            } else {
              this.$message.error('提示：' + data.Msg)
            }
          }
        })
      }).catch(_ => {
        console.log(_)
      })
    },
    couponTypeListQuery () {
      this.initData()
    },
    tabClick () {
      this.pageNo = 1
      this.total = 0
      this.initData()
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    initData () {
      var isSyn = this.couponTypeActiveName === 'syncouponTypeList'
      if (isSyn) {
        this.syncouponTypeList = []
      } else {
        this.couponTypeList = []
      }
      this.loading = true
      api.couponTypeList({
        fCustID: this.selCustID,
        fTypeID: this.selfTypeID,
        isSync: isSyn,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              if (isSyn) {
                this.syncouponTypeList = data.Data.rows
              } else {
                this.couponTypeList = data.Data.rows
              }
              this.total = data.Data.total
            }
          } else {
            this.$message.error('提示:' + data.Msg)
          }
        }
      })
      this.loading = false
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 190000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
    this.initData()
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.statusList = [{ fTypeID: '0', Title: '特殊优惠券' }]
    // this.statusList = [{fTypeID: '0', Title: '特殊优惠券'}, {fTypeID: '1', Title: '特殊优惠卡'}]
    this.getCustByGroup().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            this.offlineCusts = custs.filter(r => r.fCustTypeID === '0') // 封闭式客户
          }
        }
      }
    })
    api.getTypeList({}).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            Object.assign(this.choiceCouponTypeList, data.Data.CouponTypeList)
            this.curRowInfo.fCouponType = data.Data.CouponTypeList_defaultValue
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
#couponType .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
#couponType
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
#couponType .is-disabled .el-input__inner,
#couponType .is-disabled .el-textarea__inner {
  color: #606266;
}
#couponType .warning-row {
  color: chocolate;
}
.couponTypeEditOrDetail .el-dialog__title {
  color: white;
}
.couponTypeEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.couponTypeEditOrDetail .el-dialog__body {
  padding-bottom: 5px;
}
.couponTypeEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
</style>
<style scoped>
.pagination {
  text-align: right;
  padding-top: 5px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/coupon/couponType.vue